import { STAGES, type MeetingDto } from "@meeting-notes/shared";

const labels: Record<string, string> = {
  stt: "음성 전사",
  transcript_analysis: "전사 분석",
  topic_segmentation: "맥락·토픽 분리",
  speaker_attribution: "화자 분리",
  agenda: "안건 정리",
  summary: "회의 요약",
  notes: "노트 요약",
  follow_ups: "F/U 정리",
  suggestions: "AI 제안",
};

export function StageProgress({ meeting }: { meeting: MeetingDto }) {
  const all = ["stt", ...STAGES];
  const stages = meeting.stages as Record<string, { status: string } | undefined>;
  const done = all.filter((s) => stages[s]?.status === "COMPLETED").length;
  return (
    <div>
      <div className="h-1.5 rounded bg-slate-800 overflow-hidden">
        <div className="h-full bg-indigo-500 transition-all" style={{ width: `${(done / all.length) * 100}%` }} />
      </div>
      <ul className="mt-3 grid grid-cols-3 gap-1 text-[11px]">
        {all.map((s) => {
          const st = stages[s]?.status ?? "PENDING";
          const cls = st === "COMPLETED" ? "text-emerald-300" : st === "RUNNING" ? "text-indigo-300 animate-pulse" : st === "FAILED" ? "text-red-300" : "text-slate-500";
          return (
            <li key={s} className={cls}>
              {st === "COMPLETED" ? "✓" : st === "RUNNING" ? "●" : st === "FAILED" ? "✕" : "○"} {labels[s]}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
